import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getBannerMessage } from '@hrms/common/service/banner/service';

const AnnouncementBanner = () => {
  const { pathname } = useLocation();
  const [message, setMessage] = useState('');

  useEffect(() => {
    getBannerMessage().then(setMessage);
  }, [pathname]);

  if (!message) return null;

  return (
    <div
      id="announcement-banner"
      role="alert"
      className="fixed top-0 left-0 right-0 z-[9999] w-full bg-red-600 text-white text-center py-2 px-4 text-sm font-medium"
    >
      {message}
    </div>
  );
};

export default AnnouncementBanner;
